import React, { useEffect, useState } from 'react';
import api from '../utils/api';
import realLogo from '../assets/real-logo.png';
import './Auth.css';

const EmailVerify = ({ language: languageProp }) => {
  const [language] = useState(() => languageProp || localStorage.getItem('language') || 'ar');
  const [status, setStatus] = useState('loading');
  const [payload, setPayload] = useState(null);
  const [error, setError] = useState('');
  const isRTL = language === 'ar';

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (!token) {
      setStatus('error');
      setError(
        language === 'ar'
          ? 'رابط التأكيد غير صالح أو مفقود'
          : 'Invalid or missing verification link'
      );
      return;
    }

    let cancelled = false;
    api
      .get('/auth/verify-email', { params: { token } })
      .then((res) => {
        if (cancelled) return;
        setPayload(res.data);
        setStatus('success');
        window.history.replaceState({}, '', '/verify-email');
      })
      .catch((err) => {
        if (cancelled) return;
        const d = err.response?.data || {};
        setError(
          language === 'ar'
            ? d.error_ar || d.error || 'تعذّر تأكيد البريد الإلكتروني'
            : d.error || d.error_ar || 'Could not verify your email'
        );
        setStatus('error');
      });

    return () => {
      cancelled = true;
    };
  }, [language]);

  const user = payload?.user || {};

  return (
    <div className="auth-container" dir={isRTL ? 'rtl' : 'ltr'}>
      <div className="auth-card auth-card--success-state">
        <div className="auth-header">
          <div className="auth-logo-container">
            <img src={realLogo} alt="Real" className="auth-logo" />
          </div>
          <p className="auth-subtitle">
            {status === 'loading'
              ? language === 'ar'
                ? 'جاري التأكيد…'
                : 'Verifying…'
              : status === 'success'
                ? language === 'ar'
                  ? 'تم تأكيد البريد'
                  : 'Email verified'
                : language === 'ar'
                  ? 'تعذّر التأكيد'
                  : 'Verification failed'}
          </p>
        </div>

        {status === 'loading' && (
          <p className="auth-success-lead" role="status">
            {language === 'ar' ? 'جاري التحقق من رابط البريد الإلكتروني…' : 'Checking your verification link…'}
          </p>
        )}

        {status === 'success' && (
          <div className="auth-registration-success" role="status" aria-live="polite">
            <p className="auth-step-badge">
              {language === 'ar' ? 'الخطوة ٢ من ٢' : 'Step 2 of 2'}
            </p>
            <div className="auth-success-visual" aria-hidden>
              <span className="auth-success-icon">✓</span>
            </div>
            <h2 className="auth-success-title">
              {language === 'ar' ? 'تم التأكيد — طلبك قيد المراجعة' : 'Verified — under review'}
            </h2>
            <p className="auth-success-lead auth-success-lead--compact">
              {language === 'ar'
                ? `سنُعلمك على ${user.email || 'بريدك'} عند الموافقة. بعدها سجّل الدخول برقم الجوال وكلمة المرور.`
                : `We'll notify you at ${user.email || 'your email'} when approved. Then sign in with your phone and password.`}
            </p>
            <a href="/" className="auth-button auth-button-success-cta" style={{ display: 'inline-block', textAlign: 'center', textDecoration: 'none' }}>
              {language === 'ar' ? 'متابعة إلى تسجيل الدخول' : 'Continue to sign in'}
            </a>
          </div>
        )}

        {status === 'error' && (
          <div className="auth-registration-closed" role="alert">
            <p className="auth-success-lead">{error}</p>
            <a href="/" className="auth-button auth-button-success-cta" style={{ display: 'inline-block', textAlign: 'center', textDecoration: 'none' }}>
              {language === 'ar' ? 'العودة للتسجيل' : 'Back to sign in'}
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmailVerify;
